import { BestValueCard, TitleDuoTone } from '@fff-web/fff-ui-shared';
import useGetPricesByPlan from '../../../../utils/hooks/useGetPricesByPlan';
import * as styles from './BestValueContainer.module.scss';

const BADGE_TEXT = 'Best Value';

const title = {
  text: 'Annual Members Save Over $1,702* a Year',
  textToChangeColor: '$1,702',
  color: '#fb6a66',
};

const BestValueContainer = () => {
  const { annualPrice } = useGetPricesByPlan();

  const formattedAnnualPrice = annualPrice && `$${annualPrice?.annualPrice}/year`;
  const { text, textToChangeColor } = title;

  return (
    <section className={styles.bestValueWrapper}>
      <TitleDuoTone text={text} textToChangeColor={textToChangeColor} />
      <BestValueCard
        badge={BADGE_TEXT}
        plan={{
          name: 'Annual',
          price: formattedAnnualPrice,
        }}
        size="large"
      />
    </section>
  );
};

export { BestValueContainer };
